import { Controller, useFormContext } from 'react-hook-form';

import { Textarea, TextFieldProps } from '@myn/mui';

type TextAreaFieldProps = {
  name: string;
} & TextFieldProps;

const TextAreaField = ({ name, ...otherProps }: TextAreaFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field }) => (
        <div className="w-full">
          <Textarea
            {...field}
            error={!!errors[name]}
            fullWidth
            {...otherProps}
            helperText={
              errors[name] ? (errors[name]?.message as unknown as string) : ''
            }
            onChange={(e) => {
              field.onChange(e);
              otherProps?.onChange?.(e);
            }}
          />
        </div>
      )}
    />
  );
};

export default TextAreaField;
